<div class="login-page" [style.background-image]="'url(' + bgLoginPath + ')'">
  <div class="login-page__container">
    <div class="login-card">
      <div class="login-card__header">
        <img src="assets/icon/logo-sso.png" alt="Cổng xác thực tập trung" class="login-card__logo">
        <h1 class="login-card__title">CỔNG XÁC THỰC TẬP TRUNG</h1>
        <p class="login-card__subtitle">Đăng nhập bằng tài khoản SSO dùng chung cho mọi hệ thống</p>
      </div>

      <form [formGroup]="form" class="login-card__form" (ngSubmit)="onSubmit()">
        <div class="login-field">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Tên đăng nhập"
            placeholderText="Nhập tên đăng nhập"
            formControlName="loginName"
            [type]="isSubmitted && f['loginName'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['loginName'].errors !== null"
            [errors]="f['loginName'].errors"
            [errorDefs]="[{ errorName: 'required', errorDescription: 'common.validate.required' | translate: {'param': 'common.user.accountName' | translate }}]">
          </hbt-input-text>
          <span class="login-field__icon login-field__icon--left" nz-icon nzType="user" nzTheme="outline"></span>
        </div>

        <div class="login-field login-field--password">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Mật khẩu"
            placeholderText="Nhập mật khẩu"
            [inputType]="isFocus ? 'text' : 'password'"
            formControlName="password"
            [type]="isSubmitted && f['password'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['password'].errors !== null"
            [errors]="f['password'].errors"
            [errorDefs]="[{ errorName: 'required', errorDescription: 'common.validate.required' | translate: {'param': 'common.user.password' | translate }}]">
          </hbt-input-text>
          <span class="login-field__icon login-field__icon--left" nz-icon nzType="lock" nzTheme="outline"></span>
          <button type="button" class="pass-eye" (click)="onLabelClick()" aria-label="Hiện/ẩn mật khẩu">
            <span *ngIf="isFocus" nz-icon nzType="eye" nzTheme="outline"></span>
            <span *ngIf="!isFocus" nz-icon nzType="eye-invisible" nzTheme="outline"></span>
          </button>
        </div>

        <div class="login-links">
          <a routerLink="/change-password" class="login-links__item">Đổi mật khẩu</a>
          <a (click)="forgotPassword()" class="login-links__item">Quên mật khẩu?</a>
        </div>

        <button type="submit" class="login__btn" nz-button>
          {{ 'common.user.login' | translate }}
        </button>

        <div class="social-login">
          <div class="divider">
            <span>HOẶC</span>
          </div>
          <button type="button" class="social-btn" (click)="loginWithOffice365()">
            <img src="https://cdn-icons-png.flaticon.com/512/732/732221.png" alt="Office 365 Logo"/>
            <span class="social-btn__text">Đăng nhập bằng tài khoản Office 365</span>
          </button>
          <p class="social-note">(Chỉ sử dụng cho tài khoản MS Office 365 của người học.)</p>
        </div>
      </form>

      <a class="login-hdsd"
         href="/help/user-manual/index.html"
         target="_blank"
         rel="noopener noreferrer">
        <span nz-icon nzType="file-word" nzTheme="outline"></span>
        Hướng dẫn sử dụng
      </a>

      <p class="login-card__footer">
        © 2026 • Cổng xác thực tập trung • Cổng đăng nhập SSO
      </p>
    </div>
  </div>
</div>
